import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';


export const createTheme = createAsyncThunk('themeSlice/createTheme', async (values) => {
  try {
    const response = await axios.post(`/Themes/createtheme`, values);
    return { status: response.status, data: response.data };
  } catch (err) {
    return { status: err.response.status, data: err.response.data };
  }
});
export const customizeTheme = createAsyncThunk('themeSlice/customizeTheme', async (formData) => {
  try {
    const response = await axios.post(`/Themes/customizetheme`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return { status: response.status, data: response.data };
  } catch (err) {
    return { status: err.response.status, data: err.response.data };
  }
});
export const getThemes = createAsyncThunk('themeSlice/getThemes', async () => {
  try {
    const response = await axios.get(`/Themes/gettheme`);
    return { status: response.status, data: response.data };
  } catch (err) {
    return { status: err.response.status, data: err.response.data };
  }
});
export const deleteTheme = createAsyncThunk('themeSlice/deleteTheme', async (values) => {
  try {
    const response = await axios.delete(`/Themes/deletetheme?id=${values}`);
    return { status: response.status, data: response.data };
  } catch (err) {
    return { status: err.response.status, data: err.response.data };
  }
});
export const getThemeBrandings = createAsyncThunk('themeSlice/getThemeBrandings', async () => {
  try {
    // Uses /Brandings/getbrandings (accepts ApiKey) instead of /Setup/getbrandings (requires Bearer token)
    const response = await axios.get(`/Brandings/getbrandings`);
    return { status: response.status, data: response.data };
  } catch (err) {
    return { status: err.response.status, data: err.response.data };
  }
});

const initialState = {
  themeForCustomize: null,
  defaultTheme: '',
  brandingData: null,
  themeData: [],
  themeloading: false,
  themeError: null,
};

const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    setThemeForCustomize: (state, action) => { state.themeForCustomize = action.payload; },
    setDefaultTheme: (state, action) => { state.defaultTheme = action.payload; },
    setBrandingData: (state, action) => { state.brandingData = action.payload; },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getThemes.pending, (state) => { state.themeloading = true; })
      .addCase(getThemes.fulfilled, (state, action) => {
        state.themeloading = false;
        if (action.payload.status === 200) { state.themeData = action.payload.data; }
        state.themeError = null;
      })
      .addCase(getThemes.rejected, (state, action) => {
        state.themeloading = false;
        state.themeData = [];
        state.themeError = action.error.message;
      });
  },
});

export const { setBaseTheme, setDefaultTheme, setThemeForCustomize, setBrandingData } = themeSlice.actions;
export default themeSlice.reducer;
